<template>
  <v-app>
    <template v-if="!loading">
      <transition name="slide-fade">
        <Application v-if="shouldRenderApplication">
          <router-view />
        </Application>
        <router-view v-else />
      </transition>
    </template>

    <template v-else>
      <div class="fill-height d-flex align-center justify-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </div>
    </template>

    <SnackBar />
  </v-app>
</template>
<script>
import Application from "./template/Application.vue";
import SnackBar from "./components/alerts/SnackBar.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Application,
    SnackBar,
  },
  computed: {
    shouldRenderApplication() {
      return (
        this.$store.getters.authenticated &&
        this.$route.meta?.requiredAuth === true
      );
    },
  },
  data() {
    return {
      // O componente começa no estado de carregamento
      loading: true,
      authenticated: false,
    };
  },
  methods: {
    ...mapActions(["initializeStore"]), // Mapeia a nova ação do Vuex
  },
  created() {
    // 1. Inicia a checagem do estado
    this.loading = true;

    // 2. Chama a ação para ler o localStorage
    this.initializeStore()
      .then(() => {
        // 3. Define loading como false APÓS a checagem, permitindo a renderização correta
        this.loading = false;
      })
      .catch(() => {
        // Garante que o loading seja falso mesmo em caso de erro de leitura
        this.loading = false;
      });
  },
};
</script>

<style lang="scss">
// Mantenha seus estilos
body {
  @include scrollbar();
}

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #e3e4e6 !important;
}

.test {
  @include font-source(2rem, $primary, 800, 2.5rem);
}

.pulse {
  @include pulse-effect($primary);
}
</style>
